import * as Yup from "yup";

const createSwitchingFormYupSchema = (inputSchema) => {
  const yupSchema = {};

  Object.keys(inputSchema).forEach((key) => {
    const field = inputSchema[key];
    let yupField;

    switch (field.type) {
      case "string":
        yupField = Yup.string();
        if (field.pattern) {
          yupField = yupField.matches(
            new RegExp(field.pattern),
            "Invalid format"
          );
        }
        if (field.matchField) {
          yupField = yupField.oneOf(
            [Yup.ref(field.matchField)],
            "Fields do not match"
          );
        }
        break;
      case "boolean":
        yupField = Yup.boolean();
        break;
      case "email":
        yupField = Yup.string().email("Invalid email format");
        break;
      case "date":
        yupField = Yup.date().typeError("Invalid date format");
        if (field.min) {
          yupField = yupField.min(
            new Date(field.min),
            `Date must be after ${new Date(field.min).toLocaleDateString('en-GB')}`
          );
        }
        if (field.max) {
          yupField = yupField.max(
            new Date(field.max),
            `Date must be before ${new Date(field.max).toLocaleDateString('en-GB')}`
          );
        }
        break;
      case "object":
        yupField = createSwitchingFormYupSchema(field.properties);
        break;
      case "number":
        yupField = Yup.number();
        break;
      default:
        throw new Error(`Unsupported field type: ${field.type}`);
    }

    if (field.valid) {
      if (field.type === "boolean") {
        // someimtes the valid field is an array of strings eg ["true", "false"]. Sometimes it's an array of booleans eg [true, false]
        yupField = yupField.oneOf(
          field.valid.map((v) => (typeof v === "string" ? v === "true" : v)), 
          (field.valid.length === 1 && String(field.valid[0]) === "true") ? "This field is required" : "Invalid value" // if valid is [true] then the field is required
        );
      } else {
        yupField = yupField.oneOf(field.valid, "Invalid value");
      }
    }

    if (field.required) {
      yupField = yupField.required("This field is required");
    } else {
      yupField = yupField.nullable(true);
    }

    yupSchema[key] = yupField;
  });

  return Yup.object().shape(yupSchema);
};

export default createSwitchingFormYupSchema;
